/*
 * @创建文件时间: 2020-02-14 10:06:42
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-28 21:45:16
 * @联系Qq:1638245306
 * @文件介绍: 灾害水毁
 */
export default [{
    path: 'wdReport',
    name: 'wdReport',
    meta: {
        title: '水毁情况统计',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/disasterWaterDamage/wdReport')
},{
    path: 'reportByWashout',
    name: 'reportByWashout',
    meta: {
        title: '水毁情况上报',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/disasterWaterDamage/reportByWashout')
}, {
    path: 'wdReportRob',
    name: 'wdReportRob',
    meta: {
        title: '抢通情况',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/disasterWaterDamage/wdReportRob') 
}, {
    path: 'wdReportRepair',
    name: 'wdReportRepair',
    meta: {
        title: '水毁修复',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/disasterWaterDamage/wdReportRepair')
}, {
    path: 'wdLossRepairSum',
    name: 'wdLossRepairSum',
    meta: {
        title: '公路灾毁损失和抢通情况',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/disasterWaterDamage/wdLossRepairSum')
}, {
    path: 'wdReconstructionPlan',
    name: 'wdReconstructionPlan',
    meta: {
        title: '灾毁恢复重建项目建议计划',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/disasterWaterDamage/wdReconstructionPlan')
}]